import { Switch as Primitive } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/lib/utils";

export function Switch({ className, ...props }: ComponentProps<typeof Primitive.Root>) {
  return (
    <Primitive.Root
      className={cn(
        "inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full bg-(--border) p-0.5 transition-colors disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-solid",
        className,
      )}
      {...props}
    >
      <Primitive.Thumb className="block size-4 rounded-full bg-white shadow-card transition-transform data-[state=checked]:translate-x-4" />
    </Primitive.Root>
  );
}
